import strings from '../../Localization/Localization';

import {
  index,
  getFromId,
  editFromId,
  newItem
} from '../../API/TicketForms';
import { form } from '../Form/ticketForms';
import { form as searchForm } from '../Form/Search/ticketForms';

import {
  technicalTicketForm as technicalTicketFormsRoutes,
  commercialTicketForm as commercialTicketFormsRoutes,
  administrativeTicketForm as administrativeTicketFormsRoutes,
  installationTicketForm as installationTicketFormsRoutes,
  terminationTicketForm as terminationTicketFormsRoutes,
  technicalGlobalTicketForm as technicalGlobalTicketFormsRoutes,
} from '../Route/routes';

import { snakeToCamel } from '../../Utils/SnakeToCamel';

function getRoutes(identifier) {
  if(identifier === 'technical') {
    return technicalTicketFormsRoutes
  }
  else if(identifier === 'commercial') {
    return commercialTicketFormsRoutes
  }
  else if(identifier === 'administrative') {
    return administrativeTicketFormsRoutes
  }
  else if(identifier === 'installation') {
    return installationTicketFormsRoutes
  }
  else if(identifier === 'termination') {
    return terminationTicketFormsRoutes
  }
  else if(identifier === 'technical_global') {
    return technicalGlobalTicketFormsRoutes
  }
  else {
    console.error("missing identifier for ticket creation : "+identifier);
  }
}

function createConf(identifier, roleIdentifier) {

  let identifierCC = snakeToCamel(identifier);

  const _index = index(identifier);
  const _getFromId = getFromId(identifier);
  const _editFromId = editFromId(identifier);
  const _newItem = newItem(identifier);

  return {
    prefix: "ticketForms/"+identifierCC,
    index: {
      pageTitle: strings.common.homepage[identifierCC+"TicketForm"],

      id: "ticketForm",
      api: _index,
      onClickItem: {
        redirect: true,
        path: (id) => getRoutes(identifier).routes.show.createPath(id)
      },

      newLink: {
        link: () => getRoutes(identifier).routes.new.createPath(),
        auth: 'ROLE_'+roleIdentifier+'_TICKET_FORM_CREATE'
      },

      searchForm: searchForm,
      computeSearch: (search) => {
        let result = {};
        if(search.name) {
          result["name"] = search.name;
        }
        return result;
      },

      availableItemDisplay:['line'],
      itemDisplay: {
        line: {
          label: (item) => item["name"],
        },
      },

      sizing: {
        numberColumn: 2,
        formSizeMd: 12
      },

      buttons: () => []
    },
    show: {
      pageTitle: strings.common.homepage[identifierCC+"TicketForm"],
      pageTitleReturnPath: () => getRoutes(identifier).routes.index.createPath(),
      breadcrumbIdentifier: "name",

      apiGet: _getFromId,

      extendedHeader: false,

      tabs: {
        main: {
          title: strings.ticketForm.tab.main,
          type: 'form',
          form: form,

          onUpdateItem: (data) => {},
          onSubmit: (entity) => {},
          postEdit: {
            type: 'tab',
            tabId: 'main'
          },

          apiGet: _getFromId,
          apiEdit: _editFromId,

          role: ['ROLE_'+roleIdentifier+'_TICKET_FORM_CREATE'],
          editable: ['ROLE_'+roleIdentifier+'_TICKET_FORM_CREATE']
        }
      }
    },
    new: {
      pageTitle: strings.ticketForm.new.title,

      api: _newItem,
      empty: {},
      form: form,
      onSubmit: (item) => {},
      postNew: {
        type: 'path',
        path: (id) => getRoutes(identifier).routes.show.createPath(id)
      }
    }
  }
}

export const technicalTicketFormConf = createConf('technical', 'TECHNICAL');
export const commercialTicketFormConf = createConf('commercial', 'COMMERCIAL');
export const administrativeTicketFormConf = createConf('administrative', 'ADMINISTRATIVE');

export const installationTicketFormConf = createConf('installation', 'TECHNICAL');
export const terminationTicketFormConf = createConf('termination', 'TECHNICAL');

export const technicalGlobalTicketFormConf = createConf('technical_global', 'TECHNICAL');
